"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultTheme = exports.defaultFilters = exports.defaultPageSize = exports.defaultLocale = exports.defaultSubjectHeight = exports.defaultMessageHeight = exports.defaultElementsPerPage = exports.defaultCardHeight = void 0;
exports.defaultCardHeight = 120;
exports.defaultElementsPerPage = 4;
exports.defaultMessageHeight = 20;
exports.defaultSubjectHeight = 25;
exports.defaultLocale = 'ru';
exports.defaultPageSize = 10;
exports.defaultFilters = {
    sort: [{ created: 'desc' }, { id: 'desc' }],
    pageSize: exports.defaultPageSize,
};
exports.defaultTheme = {
    card: {
        hover: '#EEF9FF',
        background: '#F5F5F5',
    },
    status: {
        active: '#EB5757',
        border: '#E0E0E0',
    },
};
